<template>
  <v-app>
    <template v-if="$route.meta.private">
      <AdminDesign>
        <router-view></router-view>
      </AdminDesign>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
    <ClosableAlerts ref="closableAlerts" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import AdminDesign from '@/infrastructure/vue/layouts/AdminDesign';
import ClosableAlerts from '@/infrastructure/vue/components/common/alerts/ClosableAlerts';
export default {
  name: 'App',
  components: {
    AdminDesign,
    ClosableAlerts,
  },
  computed: {
    ...mapGetters('login', ['isAuthenticated', 'assignmentDetail']),
  },
  data: () => ({}),
  created() {
    window.getApp = this;
  },
  mounted() {
    this.$store.dispatch('initApplication');
  },
  watch: {
    async isAuthenticated(newValue) {
      if (newValue) {
        await this.$store.dispatch('login/userDataAction');
        this.$store.commit('box/SET_ASSIGNMENT_DETAIL', this.assignmentDetail);
      }
    },
  },
};
</script>
